import type { LucideIcon } from 'lucide-react';
import { Link2, Image as ImageIcon, FileImage, File, FileText } from 'lucide-react';
import { isEmbedSystemTag } from './system-tags';

export type ResourceKind = 'text' | 'link' | 'image' | 'document' | 'document-image';

export function isEmbedResource(resource: { tags?: string[] | null }): boolean {
  return (resource.tags || []).some((tag) => isEmbedSystemTag(tag));
}

export function getResourceKind(resource: {
  url: string | null;
  s3Key: string | null;
  mimeType: string | null;
  tags?: string[] | null;
}): ResourceKind {
  if (isEmbedResource(resource)) {
    return 'document-image';
  }
  if (resource.url) {
    return 'link';
  }
  if (resource.s3Key) {
    return resource.mimeType?.startsWith('image/') ? 'image' : 'document';
  }
  return 'text';
}

export const RESOURCE_KIND_ICONS: Record<ResourceKind, LucideIcon> = {
  link: Link2,
  image: ImageIcon,
  'document-image': FileImage,
  document: File,
  text: FileText,
};

export interface ResourceEntityTag {
  id: string;
  name: string;
  type: 'character' | 'location';
  documentId?: string;
}
